import User2Icon from "../../../icons/subscription-status/user-2.icon";

interface UserSectionProps {
  name?: string;
  date?: string;
}

const UserSection = ({ name, date }: UserSectionProps) => {
  return (
    <div className="d-flex align-items-center gap-8">
      <User2Icon />
      <span className="f-12 line-height-18 f-400 f-grey">{name}</span>
      <span className="f-12 line-height-18 f-400 f-grey">{date}</span>
    </div>
  );
};

export default UserSection;